import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from '../../environment.service';
import { IAirPortTranslated } from '../../../../components/popular-airlines/models/airlineInfo.models';

@Injectable({
  providedIn: 'root',
})
export class FlightSearchApiService {
  public http = inject(HttpClient);
  public env = inject(EnvironmentService);

  constructor() {}
  // flight-search-api.service.ts
  getSearchFlowMapping(searchStr: string) {
    let api = `https://backofficeapi.round-pixel.net/api/Airports?searchStr=${searchStr}`;

    return this.http.get<IAirPortTranslated[]>(api);
  }
}
